<!-- @format -->
<template>
    <section-base type="events" route="calendar" :posts="posts" />
</template>

<script>
import SectionBase from './SectionBase.vue';

export default {
    components: {
        SectionBase
    },

    props: {
        posts: {
            type: Array,
            required: true
        }
    }
};
</script>
